import React, { useState, useEffect, useRef } from 'react';
import { Container, TextInput, Select } from 'react-materialize';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import Row from '../organism/row.jsx';
import { COLOR, SIZE, KEY, LABEL, SCREEN_MEDIA, FONT_FAMILY } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes';
import LoadingSpinner from '../organism/spinner';
import { getDecorationTypesMap } from '../../utils/managersearch';

const BodyDecorationPost = () => {

    const fetchedDecorationTypeList = useDecorationTypes();
    const [decorationTyesMap, setDecorationTypesMap] = useState();

    const [isLoading, setIsLoading] = useState(true)

    const [isFormLoading, setIsFormLoading] = useState(false)

    useEffect(() => {
        if (fetchedDecorationTypeList && fetchedDecorationTypeList.length > 0) {
            setDecorationTypesMap(getDecorationTypesMap(fetchedDecorationTypeList))
        }
    }, [fetchedDecorationTypeList])

    useEffect(() => {
        if (decorationTyesMap && decorationTyesMap.length > 0) {
            setIsLoading(false)
        }
    }, [decorationTyesMap])

    const handleFileChange = () => {

    }

    const handleDecorationPost = () => {
        setIsFormLoading(true)
    }

    if (isLoading || isFormLoading) return <LoadingSpinner/>

    return(
        <Container>
            <Row>
                <form onSubmit={ handleDecorationPost }>
                <TextInput
                    label='Upload WebP'
                    type='file'
                    accept="image/webp" // Limits selection to WebP
                    onChange={ handleFileChange }
                    />
                <Select
                    id="selectTypeLv1"
                    multiple={false}
                    onChange={function noRefCheck(){}}
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}
                    >
                    {
                        decorationTyesMap[0].map((decorationType1, index) =>
                            <option value={decorationType1.id}>
                                { decorationType1.title }
                            </option>
                        )
                    }
                </Select>
                <Select
                    id="selectTypeLv2"
                    multiple={false}
                    onChange={function noRefCheck(){}}
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}
                    >
                    {
                        decorationTyesMap[1].map((decorationType2, index) =>
                            <option value={decorationType2.id}>
                                { decorationType2.title }
                            </option>
                        )
                    }
                </Select>
                <Select
                    id="selectTypeLv3"
                    multiple={false}
                    onChange={function noRefCheck(){}}
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}
                    >
                    {
                        decorationTyesMap[2].map((decorationType3, index) =>
                            <option value={decorationType3.id}>
                                { decorationType3.title }
                            </option>
                        )
                    }
                </Select>
                <Select
                    id="selectTypeLv4"
                    multiple={false}
                    onChange={function noRefCheck(){}}
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}
                    >
                    {
                        decorationTyesMap[3].map((decorationType4, index) =>
                            <option value={decorationType4.id}>
                                { decorationType4.title }
                            </option>
                        )
                    }
                </Select>
                <Select
                    id="selectTypeLv5"
                    multiple={false}
                    onChange={function noRefCheck(){}}
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}
                    >
                    {
                        decorationTyesMap[4].map((decorationType5, index) =>
                            <option value={decorationType5.id}>
                                { decorationType5.title }
                            </option>
                        )
                    }
                </Select>
                <Select
                    id="selectTypeLv6"
                    multiple={false}
                    onChange={function noRefCheck(){}}
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}
                    >
                    {
                        decorationTyesMap[5].map((decorationType6, index) =>
                            <option value={decorationType6.id}>
                                { decorationType6.title }
                            </option>
                        )
                    }
                </Select>
                <Button
                    type='submit'
                    width='120px'
                    height='46px'
                    bg_color={ COLOR.black }
                    margin='10px 0 0 0'
                    float='right'
                    onChange={ () => {} }>
                    <Label
                        text_color={ COLOR.white }
                        text_size={SIZE.subtitle}
                        font_family={FONT_FAMILY.avenirMedium}
                        margin='auto'>
                        {LABEL.send}
                    </Label>
                </Button>
                </form>
            </Row>
        </Container>
    )
};

export default BodyDecorationPost;